import { useEffect, useState } from "react";
import {
  onIdTokenChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  signOut as fbSignOut,
} from "firebase/auth";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, googleProvider, db, firebaseListo } from "./firebase";

/**
 * Sesion del sitio. Distingue dos roles:
 *  - admin  : custom claim `admin` (se asigna con npm run set-admin)
 *  - cliente: cualquier usuario autenticado, con su perfil en /usuarios/{uid}
 */
export function useAuth() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(firebaseListo);

  useEffect(() => {
    if (!firebaseListo) {
      setLoading(false);
      return;
    }

    const unsub = onIdTokenChanged(auth, async (u) => {
      if (!u) {
        setUser(null);
        setIsAdmin(false);
        setPerfil(null);
        setLoading(false);
        return;
      }

      const token = await u.getIdTokenResult();
      setUser(u);
      setIsAdmin(token.claims.admin === true);

      // Perfil del cliente: se crea la primera vez que inicia sesion.
      try {
        const ref = doc(db, "usuarios", u.uid);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setPerfil({ id: snap.id, ...snap.data() });
        } else {
          const nuevo = {
            email: u.email || "",
            nombre: u.displayName || "",
            telefono: "",
            empresa: "",
            ruc: "",
            createdAt: serverTimestamp(),
          };
          await setDoc(ref, nuevo);
          setPerfil({ id: u.uid, ...nuevo });
        }
      } catch {
        /* reglas restrictivas o sin conexion: seguimos sin perfil */
        setPerfil(null);
      }

      setLoading(false);
    });

    return unsub;
  }, []);

  async function entrarConGoogle() {
    if (!firebaseListo) throw new Error("Firebase no esta configurado.");
    await signInWithPopup(auth, googleProvider);
  }

  async function entrarConCorreo(email, password) {
    if (!firebaseListo) throw new Error("Firebase no esta configurado.");
    await signInWithEmailAndPassword(auth, email, password);
  }

  async function salir() {
    if (!firebaseListo) return;
    await fbSignOut(auth);
  }

  return {
    user,
    isAdmin,
    perfil,
    loading,
    disponible: firebaseListo,
    entrarConGoogle,
    entrarConCorreo,
    salir,
  };
}
